import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { MenuItem } from './menuItem.model';

@Injectable({
  providedIn: 'root'
})
export class MenuitemsService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }

  getAll(menuId: number) {
    return this.http.get<MenuItem[]>(this.global.APIURL + "menuItem?menuId=" + menuId);
  }

  getById(id: number) {
    return this.http.get<MenuItem>(this.global.APIURL + "menuItem/" + id);
  }

  Create(menu: any) {
    return this.http.post(this.global.APIURL + "menuItem", menu)
  }

  Update(menu: any) {
    return this.http.put(this.global.APIURL + "menuItem", menu)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "menuItem/" + id)
  }
}
